var TOP_PICKS_V2 = {
  gym: {
  classic: {
    base: [
      'mens-leggings-jiujitsu-spats',
      'mens-leggings-bjj-compression-spats',
      'mens-leggings-tiger-sports',
      'mens-leggings-hollywood-lightning'
    ],
    compression: {
      low: [
        'mens-leggings-jiujitsu-spats',
        'mens-leggings-bjj-compression-spats',
        'mens-leggings-tiger-sports',
        'mens-leggings-hollywood-lightning'
      ],
      mid: [
        'mens-leggings-tiger-sports',
        'mens-leggings-celestia',
        'mens-leggings-cyberpunk',
        'mens-leggings-geometric-glitchcore'
      ],
      high: [
        'mens-leggings-futuristic-geometric',
        'mens-leggings-geometric-color-splash',
        'mens-leggings-galactic-nebula',
        'mens-leggings-cyberpunk'
      ]
    },
      relaxed: { low: [], mid: [], high: [] }
    },

    neon: {
      base: [
        'mens-leggings-geometric-color-splash'
      ],
      compression: {
        low: [
          'mens-leggings-cyberpunk',
          'mens-leggings-hollywood-lightning',
          'mens-leggings-galactic-nebula',
          'patterned-mens-leggings-disco-shroom'
        ],
        mid: [
          'mens-leggings-tiger-sports',
          'mens-leggings-geometric-glitchcore'
        ],
        high: [
          'mens-leggings-geometric-color-splash',
          'mens-leggings-celestia',
          'patterned-mens-leggings-neon-harajuku',
          'patterned-mens-leggings-neon-memphis'
        ]
      },
      balanced: {
        low: [
          'mens-leggings-geometric-color-splash'
        ],
        mid: [
          'patterned-mens-leggings-disco-shroom'
        ],
        high: [
          'patterned-mens-leggings-blue-memphis-bauhaus'
        ]
      },
      relaxed: { low: [], mid: [], high: [] }
    },

    retro: {
      base: [
        'mens-leggings-tiger-sports'
      ],
      compression: {
        low: [
          'mens-leggings-black-roses-broken-hearts'
        ],
        mid: [
          'mens-leggings-tiger-sports'
        ],
        high: [
          'patterned-mens-leggings-blue-memphis-bauhaus'
        ]
      },
      balanced: {
        low: [],
        mid: [
          'mens-leggings-black-roses-broken-hearts'
        ],
        high: []
      },
      relaxed: { low: [], mid: [], high: [] }
    },

    dark: {
      base: [
        'mens-leggings-jiujitsu-spats'
      ],
      compression: {
        low: [
          'mens-leggings-hollywood-lightning',
          'mens-leggings-black-roses-broken-hearts',
          'patterned-mens-leggings-disco-shroom'
        ],
        mid: [
          'mens-leggings-jiujitsu-spats'
        ],
        high: []
      },
      balanced: {
        low: [
          'mens-leggings-geometric-color-splash'
        ],
        mid: [],
        high: []
      },
      relaxed: { low: [], mid: [], high: [] }
    },

    clean: {
      base: [
        'mens-leggings-futuristic-geometric'
      ],
      compression: {
        low: [
          'mens-leggings-cyberpunk',
          'mens-leggings-hollywood-lightning',
          'mens-leggings-geometric-glitchcore',
          'patterned-mens-leggings-neon-harajuku'
        ],
        mid: [
          'mens-leggings-tiger-sports',
          'mens-leggings-bjj-compression-spats'
        ],
        high: [
          'mens-leggings-futuristic-geometric',
          'mens-leggings-jiujitsu-spats'
        ]
      },
      balanced: {
        low: [],
        mid: [
          'mens-leggings-geometric-color-splash'
        ],
        high: []
      },
      relaxed: { low: [], mid: [], high: [] }
    }
  },

  pro: {
    classic: {
      base: [
        'mens-leggings-military-eagle',
        'mens-leggings-circus',
        'mens-leggings-villain-wrestler',
        'mens-leggings-superhero'
      ],
      compression: {
        low: [
          'mens-leggings-villain-wrestler',
          'mens-leggings-hollywood-lightning',
          'mens-leggings-american-slam',
          'mens-leggings-patriot',
          'mens-leggings-patriotic-american',
          'mens-leggings-pro-wrestling-style'
        ],
        mid: [
          'mens-leggings-military-glam-rock',
          'mens-leggings-crocodile',
          'mens-leggings-striped-villain',
          'mens-leggings-pink-fire'
        ],
        high: [
          'mens-leggings-military-eagle',
          'mens-leggings-circus',
          'mens-leggings-eagle-star',
          'mens-leggings-superhero',
          'mens-leggings-rainbowcore-cosplay'
        ]
      },
      balanced: {
        low: [],
        mid: [],
        high: [
          'mens-leggings-military-eagle',
          'mens-leggings-circus',
          'mens-leggings-eagle-star',
          'mens-leggings-superhero',
          'mens-leggings-rainbowcore-cosplay'
        ]
      },
      relaxed: { low: [], mid: [], high: [] }
    },

    neon: {
      base: [
        'mens-leggings-metallic-wrestler',
        'mens-leggings-pro-wrestling-harajuku'
      ],
      compression: {
        low: [
          'mens-leggings-blitz-vector',
          'mens-leggings-luchador-carnival',
          'mens-leggings-luchador-fire',
          'mens-leggings-luchador-slam',
          'mens-leggings-luchador',
          'mens-leggings-greatest-alive',
          'mens-leggings-floral-print',
          'mens-leggings-clowncore-yellow',
          'striped-festival-mens-leggings'
        ],
        mid: [
          'mens-leggings-metallic-wrestler',
          'mens-leggings-thunder-jack',
          'mens-leggings-glitter-rock',
          'patterned-mens-leggings-yellow-memphis-jazz',
          'mens-leggings-memphis-harajuku',
          'mens-leggings-color-block',
          'mens-leggings-black-rainbowcore',
          'mens-leggings-rainbowcore-cosplay'
        ],
        high: [
          'mens-leggings-wildbyte',
          'mens-leggings-fantasy-checks',
          'mens-leggings-orange-stars',
          'mens-leggings-monstera-print',
          'mens-leggings-glitchcore-harlequin',
          'mens-leggings-kitsch-glitter',
          'mens-leggings-neoncore-vibes'
        ]
      },
      balanced: {
        low: [],
        mid: [],
        high: [
          'mens-leggings-wildbyte',
          'mens-leggings-fantasy-checks',
          'mens-leggings-orange-stars',
          'mens-leggings-monstera-print',
          'mens-leggings-glitchcore-harlequin',
          'mens-leggings-kitsch-glitter',
          'mens-leggings-neoncore-vibes'
        ]
      },
      relaxed: { low: [], mid: [], high: [] }
    },

    retro: {
      base: [
        'wrestling-tights-red-leopard-skin',
        'mens-leggings-zigzags-color-block',
        'mens-leggings-pro-wrestling-stars'
      ],
      compression: {
        low: [
          'mens-leggings-pastel-rainbow',
          'mens-leggings-zigzags-color-block',
          'mens-leggings-tiger-sports',
          'mens-leggings-retro-pro-wrestling-purple',
          'mens-leggings-toy-pistols',
          'mens-leggings-pro-wrestling-tights-retro-block'
        ],
        mid: [
          'mens-leggings-macho-memphis',
          'mens-leggings-fantasy-checks',
          'mens-leggings-80s-memphis-chaotic',
          'mens-leggings-green-leopard-skin',
          'mens-leggings-rainbowcore-cosplay'
        ],
        high: [
          'wrestling-tights-red-leopard-skin',
          'mens-leggings-glitter-rock',
          'mens-leggings-pro-wrestling-stars',
          'mens-leggings-hot-pink-stars',
          'mens-leggings-pro-wrestling-harajuku'
        ]
      },
      balanced: {
        low: [],
        mid: [],
        high: [
          'wrestling-tights-red-leopard-skin',
          'mens-leggings-glitter-rock',
          'mens-leggings-pro-wrestling-stars',
          'mens-leggings-hot-pink-stars',
          'mens-leggings-pro-wrestling-harajuku'
        ]
      },
      relaxed: { low: [], mid: [], high: [] }
    },

    dark: {
      base: [
        'mens-leggings-electric-cyberpunk',
        'mens-leggings-cyber-riot',
        'mens-leggings-gothic-horror',
        'mens-leggings-mysterious-gothic'
      ],
      compression: {
        low: [
          'mens-leggings-futuresque',
          'mens-leggings-medieval-warrior'
        ],
        mid: [
          'mens-leggings-villain-wrestler',
          'mens-leggings-synth-knight',
          'mens-leggings-molten-monster'
        ],
        high: [
          'mens-leggings-electric-cyberpunk',
          'mens-leggings-cyber-riot',
          'mens-leggings-gothic-horror',
          'mens-leggings-mysterious-gothic'
        ]
      },
      balanced: {
        low: [],
        mid: [],
        high: [
          'mens-leggings-electric-cyberpunk',
          'mens-leggings-cyber-riot',
          'mens-leggings-gothic-horror',
          'mens-leggings-mysterious-gothic'
        ]
      },
      relaxed: { low: [], mid: [], high: [] }
    },

    clean: {
      base: [
        'mens-leggings-molten-monster',
        'mens-leggings-futuresque',
        'mens-leggings-gray-stripes'
      ],
      compression: {
        low: [
          'mens-leggings-synth-knight',
          'mens-leggings-thunder-jack',
          'mens-leggings-celestia',
          'mens-leggings-mysterious-gothic'
        ],
        mid: [
          'mens-leggings-futuresque',
          'mens-leggings-zigzags-color-block',
          'mens-leggings-gothic-horror',
          'mens-leggings-bjj-compression-spats',
          'striped-festival-mens-leggings'
        ],
        high: [
          'mens-leggings-molten-monster',
          'mens-leggings-red-stripes',
          'mens-leggings-gray-stripes'
        ]
      },
      balanced: {
        low: [],
        mid: [],
        high: [
          'mens-leggings-molten-monster',
          'mens-leggings-red-stripes',
          'mens-leggings-gray-stripes'
        ]
      },
      relaxed: { low: [], mid: [], high: [] }
    }
  },

  fashion: {
    classic: {
      base: [
        'patterned-mens-leggings-triangular-puzzle',
        'mens-leggings-steampunk-horology',
        'mens-leggings-watermelon',
        'mens-leggings-memphis-harajuku'
      ],
      compression: {
        low: [
          'mens-leggings-watermelon',
          'mens-leggings-memphis-harajuku',
          'patterned-mens-leggings-pastel-goth-checks',
          'patterned-mens-leggings-yellow-memphis-jazz'
        ],
        mid: [
          'mens-leggings-steampunk-horology',
          'mens-leggings-gray-stripes',
          'striped-festival-mens-leggings',
          'abstract-art-mens-leggings',
          'patterned-mens-leggings-lgbt-pride',
          'patterned-mens-leggings-blue-memphis-bauhaus',
          'patterned-mens-leggings-psychedelic-pattern-rainbow-camouflage'
        ],
        high: [
          'mens-leggings-skulls-and-roses',
          'mens-leggings-gray-stripes',
          'patterned-mens-leggings-pink-brown-leopard-skin',
          'patterned-mens-leggings-triangular-puzzle'
        ]
      },
      balanced: {
        low: [],
        mid: [],
        high: [
          'mens-leggings-steampunk-horology',
          'mens-leggings-gray-stripes',
          'striped-festival-mens-leggings',
          'abstract-art-mens-leggings',
          'patterned-mens-leggings-lgbt-pride',
          'patterned-mens-leggings-blue-memphis-bauhaus',
          'patterned-mens-leggings-psychedelic-pattern-rainbow-camouflage'
        ]
      },
      relaxed: {
        low: [
          'patterned-mens-leggings-triangular-puzzle',
          'mens-leggings-steampunk-horology'
        ],
        mid: [],
        high: [
          'mens-leggings-memphis-harajuku',
          'mens-leggings-watermelon',
          'patterned-mens-leggings-triangular-puzzle'
        ]
      }
    },

    neon: {
      base: [
        'mens-leggings-watermelon',
        'groovy-70s-flower-power-mens-leggings'
      ],
      compression: {
        low: [
          'groovy-70s-flower-power-mens-leggings',
          'mens-leggings-trippy-clubbing-outfit',
          'creepy-cute-decora-kei-mens-leggings',
          'mens-leggings-green-anime',
          'patterned-mens-leggings-disco-shroom'
        ],
        mid: [
          'mens-leggings-watermelon',
          'mens-leggings-celestia',
          'mens-leggings-zigzags',
          'abstract-art-mens-leggings',
          'mens-leggings-pink-blue-crazy-underworld-collection'
        ],
        high: [
          'mens-leggings-geometric-glitchcore',
          'mens-leggings-subatomic',
          'vaporwave-menhera-meggings',
          'patterned-mens-leggings-neon-memphis',
          'patterned-mens-leggings-mid-century-geometric',
          'neoncore-edm-rave-mens-leggings'
        ]
      },
      balanced: {
        low: [],
        mid: [],
        high: [
          'mens-leggings-watermelon',
          'mens-leggings-celestia',
          'mens-leggings-zigzags',
          'abstract-art-mens-leggings',
          'mens-leggings-pink-blue-crazy-underworld-collection'
        ]
      },
      relaxed: { low: [], mid: [], high: [] }
    },

    retro: {
      base: [
        'mens-leggings-watermelon',
        'groovy-70s-flower-power-mens-leggings'
      ],
      compression: {
        low: [
          'mens-leggings-watermelon',
          'christmas-meggings-in-fairisle-print',
          'creepy-cute-decora-kei-mens-leggings'
        ],
        mid: [
          'mens-leggings-edm-rave-glitter'
        ],
        high: [
          'groovy-70s-flower-power-mens-leggings'
        ]
      },
      balanced: {
        low: [],
        mid: [],
        high: [
          'mens-leggings-edm-rave-glitter'
        ]
      },
      relaxed: { low: [], mid: [], high: [] }
    },

    dark: {
      base: [
        'mens-leggings-steampunk-macabre',
        'mens-leggings-steampunk-horology',
        'mens-leggings-skulls-and-roses'
      ],
      compression: {
        low: [
          'mens-leggings-skulls-and-roses',
          'patterned-mens-leggings-disco-shroom'
        ],
        mid: [
          'mens-leggings-weirdcore-skulls'
        ],
        high: [
          'mens-leggings-steampunk-macabre',
          'mens-leggings-steampunk-horology'
        ]
      },
      balanced: {
        low: [],
        mid: [],
        high: [
          'mens-leggings-steampunk-macabre',
          'mens-leggings-steampunk-horology',
          'mens-leggings-skulls-and-roses'
        ]
      },
      relaxed: { low: [], mid: [], high: [] }
    },

    clean: {
      base: [
        'mens-leggings-gray-stripes',
        'mens-leggings-geometric-glitchcore'
      ],
      compression: {
        low: [
          'patterned-mens-leggings-neon-harajuku',
          'patterned-mens-leggings-pastel-goth-checks',
          'patterned-mens-leggings-blue-memphis-bauhaus'
        ],
        mid: [
          'mens-leggings-geometric-glitchcore',
          'patterned-mens-leggings-yellow-memphis-jazz'
        ],
        high: [
          'mens-leggings-gray-stripes'
        ]
      },
      balanced: {
        low: [],
        mid: [],
        high: [
          'mens-leggings-gray-stripes'
        ]
      },
      relaxed: { low: [], mid: [], high: [] }
    }
  },

  bundles: {
    classic: {
      base: [
        'wrestling-cosplay-outfit-eagle-command-bundle',
        'pink-fire-bundle'
      ],
      compression: {
        low: [],
        mid: [
          'pink-fire-bundle'
        ],
        high: []
      },
      balanced: {
        low: [],
        mid: [],
        high: [
          'wrestling-cosplay-joggers-bomber-jacket-eagle-star'
        ]
      },
      relaxed: {
        low: [],
        mid: [],
        high: [
          'wrestling-cosplay-joggers-bomber-jacket-eagle-star'
        ]
      }
    },

    neon: {
      base: [
        'pro-wrestling-stars-bundle-pink',
        'pro-wrestling-bundle-hot-pink',
        'wrestling-cosplay-outfit-wildbyte-bundle'
      ],
      compression: {
        low: [
          'wrestling-cosplay-outfit-neon-bolt-kid-bundle'
        ],
        mid: [
          'wrestling-cosplay-outfit-wildbyte-bundle',
          'wrestling-cosplay-outfit-thunder-jack-bundle'
        ],
        high: [
          'pro-wrestling-bundle-hot-pink',
          'pro-wrestling-stars-bundle-pink'
        ]
      },
      balanced: { low: [], mid: [], high: [] },
      relaxed: { low: [], mid: [], high: [] }
    },

    retro: {
      base: [
        'wrestling-cosplay-outfit-rainbowcore-bundle',
        'pro-wrestling-harajuku-bundle-pink',
        'pro-wrestling-stars-bundle-black',
        'wrestling-cosplay-outfit-macho-metro-bundle'
      ],
      compression: {
        low: [
          'pro-wrestling-bundle-blue'
        ],
        mid: [
          'pro-wrestling-stars-bundle-black'
        ],
        high: [
          'pro-wrestling-harajuku-bundle-pink'
        ]
      },
      balanced: { low: [], mid: [], high: [] },
      relaxed: { low: [], mid: [], high: [] }
    },

    dark: {
      base: [
        'wrestling-cosplay-outfit-cyber-riot-bundle',
        'wrestling-cosplay-outfit-synth-knight-bundle'
      ],
      compression: {
        low: [
          'wrestling-cosplay-outfit-synth-knight-bundle'
        ],
        mid: [],
        high: []
      },
      balanced: { low: [], mid: [], high: [] },
      relaxed: { low: [], mid: [], high: [] }
    },

    clean: {
      base: [
        'wrestling-cosplay-outfit-neon-bolt-kid-bundle',
        'watermelon-cosplay-activewear-bold-bright-and-battle-ready'
      ],
      compression: {
        low: [
          'pro-wrestling-stars-bundle-green',
          'pro-wrestling-stars-bundle-blue'
        ],
        mid: [
          'pro-wrestling-stars-bundle-orange'
        ],
        high: []
      },
      balanced: { low: [], mid: [], high: [] },
      relaxed: { low: [], mid: [], high: [] }
    }
  }
};


